import { useBunja } from 'bunja/react';
import { useAtomValue } from 'jotai';

import { LaunchpoolStatus } from '@flipster/apis/v1/launchpool/types';
import { launchpoolItemBunja } from '@flipster/features/src/shared/launchpool/state';
import { useResponsive } from '@flipster/react/misc/responsive/legacy';
import { css } from '@flipster/styled-system/css';

import ConvertInfo from '@web/app/[locale]/(web)/launchpool/_lists/_Item/ConvertInfo';

import BottomSection from './BottomSection';
import CurrencyInfo from './CurrencyInfo';
import LaunchpoolInfo from './LaunchpoolInfo';
import TotalReward from './TotalReward';
import TradingMultipliers from './TradingMultiplier';

const LaunchpoolItem = () => {
  const { isMobile } = useResponsive();
  const { launchpoolItemAtom } = useBunja(launchpoolItemBunja);
  const launchpool = useAtomValue(launchpoolItemAtom);

  const isClosed = launchpool.status === LaunchpoolStatus.Closed;
  const isUserStaked = Number(launchpool.stakedAmount) !== 0;
  const isHideTotalReward = isClosed && Number(launchpool.stakedAmount) === 0;
  const isHideMultipliers = isMobile && isHideTotalReward;

  return (
    <section className={css({ mt: { base: 32, tablet: 40 } })}>
      <CurrencyInfo />
      {isClosed && isUserStaked && !launchpool.autoConversionOn && launchpool.stakingCurrency != 'USDT' && (
        <ConvertInfo />
      )}
      <div className={css({ pt: 12, pb: 16, px: 16, bgColor: 'background.default.level-1', rounded: 8 })}>
        <div
          className={css({ display: 'flex', gap: { base: 16, tablet: 32 }, flexDirection: { tabletDown: 'column' } })}
        >
          <LaunchpoolInfo />
          {!isHideMultipliers && <TradingMultipliers />}
        </div>
        {!isHideTotalReward && <TotalReward />}
        <BottomSection />
      </div>
    </section>
  );
};

export default LaunchpoolItem;
